import { useState } from 'react';
import { apiClient } from '../../api/ApiClient';

const useZipcodeLookup = () => {
    const [zipcodeCity, setZipcodeCity] = useState('');
    const [zipcodeState, setZipcodeState] = useState('');
    const [zipError, setZipError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const checkZipCode = async (e) => {
        const zipcode = e.target.value;
        
        // Basic validation
        if (!zipcode || zipcode.length !== 5) {
            setZipError('Please enter a valid 5-digit zipcode');
            setZipcodeCity('');
            setZipcodeState('');
            return;
        }

        setIsLoading(true);
        setZipError('');

        try {
            const response = await apiClient.get(`/rest/ziplookup/${zipcode}`);
            const data = response.data;

            if (data && data.cityName && data.state) {
                setZipcodeCity(data.cityName);
                setZipcodeState(data.state);
                setZipError('');
            } else {
                setZipError('Invalid zipcode');
                setZipcodeCity('');
                setZipcodeState('');
            }
        } catch (error) {
            console.error('Zipcode lookup error:', error);
            setZipError(
                error.response?.data?.message || 
                'Unable to verify zipcode at this time. Please try again later.'
            );
            setZipcodeCity('');
            setZipcodeState('');
        } finally {
            setIsLoading(false);
        }
    };

    return {
        zipcodeCity,
        zipcodeState,
        zipError,
        isLoading,
        checkZipCode,
    };
};

export default useZipcodeLookup;